export default __webpack_public_path__ + "static/media/signup.4fd55c4d.png";